import Pill from '@pelckmans/elementis/components/pill';
import WarningIcon from '@pelckmans/elementis/icons/warning';
import { Result } from '../../../../../utils/results';
import { useTranslation } from 'react-i18next';
import { formatAbsoluteScore, formatPercentage } from '@pelckmans/elementis/components/results';

type ScoreIndicatorProps = {
  result: Result;
  showScore?: boolean;
};

const TRANSLATION_BASE = 'PAGES.RESULTS.MODALS.SMARTSCHOOL_SKORE_EXPORT.LIST';

function ScoreIndicator({ result, showScore = false }: ScoreIndicatorProps) {
  const { t } = useTranslation();

  const formatScore = (result: Result, showScore: boolean) => {
    if (!result.score || result.score.achievable === 0)
      return <span className="score">{t(`${TRANSLATION_BASE}.NO_SCORE`)}</span>;

    if (showScore) return <span className="score">{formatAbsoluteScore(result.score)}</span>;

    return <Pill>{formatPercentage(result.score)}</Pill>;
  };

  return (
    <>
      {formatScore(result, showScore)}
      {result.isSmartschoolSynced && <Pill data-testid="skore-synced" prominence="warning" icon={<WarningIcon />} />}
    </>
  );
}

export default ScoreIndicator;
